/**
 * Read-only status pill: same size, shape and spacing for every status, one line, icon + text
 * (never colour alone). Actions are separate buttons; a pill is never clickable.
 */

import { cn } from '@/lib/utils';
import type { StatusLook, StatusTone } from './participantStatus';

const TONE: Record<StatusTone, string> = {
  success: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-400',
  warning: 'bg-amber-500/15 text-amber-700 dark:text-amber-400',
  danger: 'bg-red-500/15 text-red-700 dark:text-red-400',
  neutral: 'bg-muted text-muted-foreground',
};

export function StatusPill({ look, className }: { look: StatusLook; className?: string }) {
  const Icon = look.icon;
  return (
    <span
      className={cn(
        'inline-flex h-6 items-center gap-1 whitespace-nowrap rounded-full px-2.5 text-xs font-medium',
        TONE[look.tone],
        className,
      )}
    >
      <Icon className="size-3 shrink-0" aria-hidden="true" />
      {look.label}
    </span>
  );
}
